import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate("/auth", { replace: true });
    }
    if (!loading && user && role && user.role !== role) {
      // Redirect to correct dashboard
      if (user.role === "super_admin") navigate("/super-admin", { replace: true });
      else if (user.role === "admin") navigate("/admin", { replace: true });
      else if (user.role === "driver") navigate("/driver", { replace: true });
      else navigate("/customer", { replace: true });
    }
  }, [user, loading, navigate, role]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-3 border-forest border-t-transparent rounded-full animate-spin" />
          <p className="text-forest/60 font-body text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || (role && user.role !== role)) return null;

  return children;
}
